import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const upcomingAppointmentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getUpcomingAppointments: builder.query({
      query: ({
        patientProfileId,
        preferredLanguage
      }: {
        patientProfileId: number;
        preferredLanguage: string;
      }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = preferredLanguage;
        return {
          url: `/api/v1/Appointment/${patientProfileId}/spotlight-upcoming-appointments`,
          method: "GET",
          headers,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetUpcomingAppointmentsQuery } =
upcomingAppointmentsApi;
export default upcomingAppointmentsApi;
